import { render } from "./ClientRequestView.vue?vue&type=template&id=c49d0762"
import script from "./ClientRequestView.vue?vue&type=script&lang=js"
export * from "./ClientRequestView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__